// extracted by mini-css-extract-plugin
export default {"base":"BillDetailHeader_base__zppUo"};